import UploadRecorderNoticeCard from '@/components/notice/UploadRecorderNoticeCard';
import RightRecorderNoticeCard from '@/components/notice/RightRecorderNoticeCard';
import eventBus from '@/plugins/eventBus';
import { useGetter } from 'common-module/src/util/useVuex';
import { openRecordPreviewDialog } from '@/components/float-btn/recorder/recorder-preview-dialog';

export default (notice, h) => {
  eventBus.$on('recorder:uploader', (recordUpload, data) => {
    if (data.from === 'issueDesc') {
      notice({
        fixedFlag: true,
        duration: 0,
        customClass: 'zk-notice-card zk-upload-recorder-notice',
        message: h(UploadRecorderNoticeCard, {
          props: {
            recordUpload,
            ...data
          }
        })
      });
    } else {
      openRecordPreviewDialog({
        recordUpload
      });
    }
    
  });

  eventBus.$on('recorder:right', ({ limitTime }) => {
    const productRights = useGetter('user/userProductRights');
    const isProfessional = productRights?.productSchemeVO?.schemeType === 3; // 是否是专业版
    if (isProfessional) {
      return;
    }
    notice({
      fixedFlag: true,
      duration: 0,
      customClass: 'zk-notice-card zk-right-recorder-notice-card',
      message: h(RightRecorderNoticeCard, {
        props: { limitTime }
      })
    });
  });
};

eventBus.$on('record:preview', (previewData) => {
  openRecordPreviewDialog({
    previewData
  });
});

